import dotObject from 'dot-object';
import Pagination from './pagination';

export default class APINamespace {
  constructor(client, baseURL, handlers) {
    this.BASE_URL = baseURL;
    this.CLIENT = client;
    this.request = this.request.bind(this);
    this.handlers = handlers(this.request);
  }

  /**
   * Perform XHR request
   * @param {String} method - method name (GET|POST|PUT|DELETE)
   * @param {String} relUrl - url relative to module namespace
   * @param {Object} payload - request body
   */
  async request(method, relUrl = '', payload, options) {
    const { BASE_URL, CLIENT } = this;
    const methodName = method.toLowerCase();
    const url = BASE_URL + relUrl;

    let response;

    try {
      response = (await CLIENT[methodName](url, payload, options)) || {};
    } catch (e) {
      ({ response = {} } = e);
    }

    const { headers = {} } = response;
    const { violations = [] } = dotObject.pick('data.data.error.details', response) || {};
    const errors = violations.reduce((res, violation) => {
      const { status, propertyPath } = violation;

      if (propertyPath) {
        const name = propertyPath
          .replace(/children\[/g, '')
          .replace(/\]/g, '')
          .split('.')
          .filter(key => key !== 'data')
          .join('.');

        res.push({ name, status });
      }

      return res;
    }, []);

    const data = dotObject.pick('data.data', response);
    const status = response.status || -1;
    const success = status >= 200 && status < 300;
    const message =
      dotObject.pick('error.details.message', data) ||
      dotObject.pick('data.message', response) ||
      '';
    let pagination = {};

    if ('x-count' in headers) {
      pagination = new Pagination({
        page: headers['x-page'],
        perPage: headers['x-per-page'],
        total: headers['x-total-count'],
        count: headers['x-count'],
      });
    }

    return {
      status,
      response,
      success,
      errors,
      data,
      message,
      pagination,
    };
  }
}
